module.exports = __webpack_public_path__ + "img/report-8.083348e8.jpg";